module.exports = __webpack_public_path__ + "img/rice-1.60204753.jpg";